import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { brandPrimary, darkGrayFontColor } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	clear: {
		color: brandPrimary,
		marginLeft: 10,
	},
	dateSelect: {
		borderRadius: 6,
		flex: 1,
		marginLeft: 10,
		minWidth: 0,
	},
	exportButton: {
		marginLeft: 10,
	},
	exportDialogCheckboxRow: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'flex',
		gap: 8,
	},
	exportConfirmationNote: {
		marginTop: 8,
	},
	exportDialogDescription: {
		color: darkGrayFontColor,
		fontSize: 13,
		lineHeight: 1.4,
		marginLeft: 28,
		marginTop: 4,
	},
	exportTooLargeSuggestions: {
		color: darkGrayFontColor,
		fontSize: 13,
		lineHeight: 1.5,
		marginTop: 4,
		paddingLeft: 20,
	},
	exportTooLargeSuggestionsHeading: {
		fontWeight: 600,
		marginTop: 16,
	},
	filterSelect: {
		borderRadius: 6,
		flex: 1,
		marginLeft: 10,
		minWidth: 0,
	},
	filterSelectOption: {
		width: 248,
	},
	note: {
		':not(:last-child)': {
			marginBottom: 15,
		},
		boxSizing: 'border-box',
		width: 'calc(100% - 5px)',
	},
	notesList: {
		boxSizing: 'border-box',
		flex: 1,
		maxWidth: '100%',
		overflowY: 'auto',
		padding: '0 5px 20px 0',
		width: '100%',
	},
	notesListContainer: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
	searchContainer: {
		display: 'flex',
		flex: '1 1 620px',
		justifyContent: 'space-between',
		minWidth: 0,
	},
	searchField: {
		flex: 1,
		minWidth: 0,
	},
	searchHeader: {
		alignItems: 'center',
		background: '#fff',
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.sm,
		justifyContent: 'space-between',
		padding: '8px 0',
	},
	searchHeaderWrap: {
		display: 'flex',
		width: '100%',
	},
	searchLeft: {
		flex: '1 1 260px',
		minWidth: 0,
	},
	sortSelect: {
		borderRadius: 6,
		flex: 2,
		minWidth: 0,
	},
});
